import React, { useContext } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';

import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { PageContext } from '@xingternal/pages-common';

import styles from './UpsellBanner.css';
import { getMarketingPageUrl } from './utils';

type UpsellBannerProps = {
  headerCopyKey: string;
  bodyCopyKey: string;
  moduleName: string;
  column?: boolean;
};

const UpsellBanner = ({
  headerCopyKey,
  bodyCopyKey,
  column,
  moduleName,
}: UpsellBannerProps) => {
  const { pageContext } = useContext(PageContext);
  const intl = useIntl();

  const marketingPageUrl = getMarketingPageUrl({
    locale: intl.locale,
    moduleName,
    focusType: pageContext?.focusType,
  });

  return (
    <div
      className={cx(
        styles.premiumWrapper,
        column ? styles.upsellColumn : styles.centered
      )}
    >
      <div className={styles.textWrapper}>
        <span className={styles.flag}>
          <FormattedMessage id="EP_FLAG_EMPLOYER_BRANDING_PROFILE" />
        </span>
        <div className={styles.headerText}>
          <Headline size="xlarge">
            <FormattedMessage id={headerCopyKey} />
          </Headline>
        </div>
        <BodyCopy className={styles.text}>
          <FormattedMessage id={bodyCopyKey} />
        </BodyCopy>
      </div>
      <div className={styles.premiumButtonMargin}>
        <Button
          size="medium"
          variant="proBusiness"
          className={styles.premiumButton}
          href={marketingPageUrl}
          target="_blank"
          rel="noreferrer noopener nofollow"
        >
          <FormattedMessage id="EP_UPSELL_GALLERY_BUTTON" />
        </Button>
      </div>
    </div>
  );
};

export default UpsellBanner;
